import {
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from "@heroui/react"
import { Trans } from "@lingui/react/macro"
import { useMemo } from "react"

import type { Entry } from "../har"

export function CookiesTab({ entry }: { entry?: Entry }) {
  const response = entry?.response

  const sorted = useMemo(
    () => response?.cookies.sort((a, b) => a.name.localeCompare(b.name)) ?? [],
    [response?.cookies]
  )

  if (!entry) {
    return null
  }

  return (
    <div css="mx-4 my-3">
      <h3 css="mb-2 ml-1 text-sm font-medium uppercase tracking-widest opacity-50">
        Cookies
      </h3>
      <Table hideHeader isStriped aria-label="Headers">
        <TableHeader>
          <TableColumn>
            <Trans>Title</Trans>
          </TableColumn>
          <TableColumn>
            <Trans>Value</Trans>
          </TableColumn>
        </TableHeader>
        <TableBody emptyContent={<Trans>No cookie to display.</Trans>}>
          {sorted.map(cookie => (
            <TableRow key={cookie.name + cookie.value}>
              <TableCell css="w-48 align-top !font-medium">{cookie.name}</TableCell>
              <TableCell css="max-w-64 text-wrap break-words" height={35}>
                {cookie.value === "" ? (
                  <span css="italic opacity-40">
                    <Trans>Empty</Trans>
                  </span>
                ) : (
                  cookie.value
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
